import FormType from '@/models/Forms/FormType';

export default class FormTypeViewModel {
    name: string;
    value: FormType;

    public constructor(name: string, value: FormType) {
        this.name = name;
        this.value = value;
    }
}